module.exports = __webpack_public_path__ + "img/Move.f6b19319.svg";